export const normalizarEmail = (email) => (email || "").trim();

export const normalizarTelefono = (telefono) => (telefono || "").trim();

/**
 * Retorna true si el email es válido, false en caso contrario.
 * El email vacío se considera inválido (obligatorio).
 */
export const validarEmail = (email) => {
    const correo = normalizarEmail(email);
    if (!correo) return false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(correo);
};

/**
 * Retorna true si el teléfono chileno es válido o está vacío.
 * - El campo puede ir vacío (no obligatorio).
 * - Si tiene dígitos:
 *   - Entre 9 y 11 dígitos.
 *   - Si tiene 11, debe comenzar con 56 (código país).
 */
export const validarTelefonoChileno = (telefono) => {
    const telefonoNormalizado = normalizarTelefono(telefono);
    const telefonoLimpio = telefonoNormalizado.replace(/\D/g, "");

    if (!telefonoLimpio) return true;

    if (
        telefonoLimpio.length < 9 ||
        telefonoLimpio.length > 11 ||
        (telefonoLimpio.length === 11 && !telefonoLimpio.startsWith("56"))
    ) {
        return false;
    }

    return true;
};

export const getPasswordStrength = (value) => {
    const password = value || "";
    let score = 0;

    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    let label = "Débil";
    let color = "#dc3545";

    if (score >= 3 && score <= 4) {
        label = "Media";
        color = "#ffc107";
    } else if (score >= 5) {
        label = "Fuerte";
        color = "#28a745";
    }

    const percent = Math.min(score * 20, 100);

    return { label, color, value: percent };
};